import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'titleCaseExtended'
})
export class TitleCaseExtendedPipe extends TitleCasePipe implements PipeTransform {
  constructor() {
    super();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override transform(value: any, ...args: any[]): any {
    const obj = args[0];
    if (obj.letter === 'firstletter') {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    } else {
      return super.transform(value);
    }
  }
}
